
//import static_cards from '../../library/cards.json';
//import static_champions from '../../library/champions.json';
//import static_fights from '../../library/fights.json';
import static_spirits from '../../library/spirits.json';
//import static_casual_enemies from '../../library/casual_enemies.json';
//import static_challenge_enemies from '../../library/challenge_enemies.json';
//import static_statuses from '../../library/statuses.json';
//import static_relics from '../../library/relics.json';
//import static_potions from '../../library/potions.json';
import static_quests from '../../library/quests.json';
import User from '../../User';
import { getLanguage } from '../../TextManager';

const CASUAL_HP_RATIO = 0.7;
const HARDCORE_HP_RATIO = 1.3;

const lang = getLanguage();

export function loadStaticData(context) {
  const data = {};

  context.keys().forEach((path) => {
    // Some setups (esbuild, vite) may wrap JSON as { default: ... }
    const mod = context(path);
    const value =
      mod && typeof mod === 'object' && 'default' in mod && typeof mod.default === 'object'
        ? mod.default
        : mod;

    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      console.warn(`Unsupported export in ${path}; expected an object.`);
      return;
    }

    // CASE 1: single element with a "key"
    if ('key' in value) {
      const k = value.key;
      if (!k) {
        console.warn(`Missing "key" in: ${path}`);
        return;
      }
      if (data[k]) {
        console.warn(`Duplicate key "${k}" from ${path}; overwriting previous entry.`);
      }
      data[k] = value;
      return;
    }

    // CASE 2: dictionary of elements — merge entries
    Object.entries(value).forEach(([dictKey, obj]) => {
      if (!obj || typeof obj !== 'object') {
        console.warn(`Entry "${dictKey}" in ${path} is not an object; skipped.`);
        return;
      }

      // Prefer the object's own key if present; otherwise fall back to the map key
      const k = obj.key ?? dictKey;

      if (!k) {
        console.warn(`Missing "key" for entry "${dictKey}" in ${path}; skipped.`);
        return;
      }

      if ('key' in obj && obj.key !== dictKey) {
        console.warn(
          `Mismatched keys in ${path}: map key "${dictKey}" !== object.key "${obj.key}". Using "${obj.key}".`
        );
      }

      if (data[k]) {
        console.warn(`Duplicate key "${k}" from ${path}; overwriting previous entry.`);
      }

      // Ensure the stored object’s key matches the final index
      data[k] = { ...obj, key: k };
    });
  });

  return data;
}

const static_cards = loadStaticData(require.context('../../library/cards', true, /\.json$/));
const static_champions = loadStaticData(require.context('../../library/champions', true, /\.json$/));
const static_fights = loadStaticData(require.context('../../library/fights', true, /\.json$/));
const static_acts = loadStaticData(require.context('../../library/acts', true, /\.json$/));
const static_events = loadStaticData(require.context('../../library/events', true, /\.json$/));
const static_enemies = loadStaticData(require.context('../../library/enemies', true, /\.json$/));
const static_statuses = loadStaticData(require.context('../../library/statuses', true, /\.json$/));
const static_curses = loadStaticData(require.context('../../library/curses', true, /\.json$/));
const static_relics = loadStaticData(require.context('../../library/relics', true, /\.json$/));
const static_potions = loadStaticData(require.context('../../library/potions', true, /\.json$/));
const static_companions = loadStaticData(require.context('../../library/companions', true, /\.json$/));

const DYNAMIC_LIBRARY = false;

let cards = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.cards')) : static_cards;
let champions = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.champions')) : static_champions;
let fights = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.fights')) : static_fights;
let acts = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.acts')) : static_acts;
let events = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.events')) : static_events;
let spirits = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.spirits')) : static_spirits;
//let casualenemies = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.casualenemies')) : static_casual_enemies;
let enemies = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.enemies')) : static_enemies;
let statuses = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.statuses')) : static_statuses;
let curses = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.curses')) : static_curses;
let relics = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.relics')) : static_relics;
let potions = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.potions')) : static_potions;
let companions = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.companions')) : static_companions;
let quests = DYNAMIC_LIBRARY ? JSON.parse(localStorage.getItem('library.quests')) : static_quests;

let cardsversion = localStorage.getItem('library.cards.version');
let championsversion = localStorage.getItem('library.champions.version');
let fightsversion = localStorage.getItem('library.fights.version');
let actsversion = localStorage.getItem('library.acts.version');
let eventsversion = localStorage.getItem('library.events.version');
let spiritsversion = localStorage.getItem('library.spirits.version');
//let casualenemiesversion = localStorage.getItem('library.casualenemies.version');
let enemiesversion = localStorage.getItem('library.enemies.version');
let statusesversion = localStorage.getItem('library.statuses.version');
let cursesversion = localStorage.getItem('library.curses.version');
let relicsversion = localStorage.getItem('library.relics.version');
let potionsversion = localStorage.getItem('library.potions.version');
let companionsversion = localStorage.getItem('library.companions.version');
let questsversion = localStorage.getItem('library.quests.version');

export default class Library {

	static get cards () {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.cards.version') !== cardsversion) {
			cards = JSON.parse(localStorage.getItem('library.cards'));
			cardsversion = localStorage.getItem('library.cards.version');
		}
		return Object.fromEntries(Object.entries(cards).map(([key, value]) => [key, Library.upgradeCard(value)]));
	}

	static get rawcards () {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.cards.version') !== cardsversion) {
			cards = JSON.parse(localStorage.getItem('library.cards'));
			cardsversion = localStorage.getItem('library.cards.version');
		}
		return cards;
	}

	static get champions () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.champions.version') !== championsversion) {
			champions = JSON.parse(localStorage.getItem('library.champions'));
			championsversion = localStorage.getItem('library.champions.version');
		}
		return champions;
	}

	static get fights () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.fights.version') !== fightsversion) {
			fights = JSON.parse(localStorage.getItem('library.fights'));
			fightsversion = localStorage.getItem('library.fights.version');
		}
		return fights;
	}

	static get acts () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.acts.version') !== actsversion) {
			acts = JSON.parse(localStorage.getItem('library.acts'));
			actsversion = localStorage.getItem('library.acts.version');
		}
		return acts;
	}

	static get events () {

		return Library.getEvents();
	}

	static getEvents (power=1) {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.events.version') !== eventsversion) {
			events = JSON.parse(localStorage.getItem('library.events'));
			eventsversion = localStorage.getItem('library.events.version');
		}
		return Object.fromEntries(Object.entries(events).map(([key, value]) => [key, Library.upgradeItem(value, power)]));
	}

	static get spirits () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.spirits.version') !== spiritsversion) {
			spirits = JSON.parse(localStorage.getItem('library.spirits'));
			spiritsversion = localStorage.getItem('library.spirits.version');
		}
		return Object.fromEntries(Object.entries(spirits).map(([key, value]) => [key, Library.upgradeItem(value)]));
	}

	static get enemies () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.enemies.version') !== enemiesversion) {
			enemies = JSON.parse(localStorage.getItem('library.enemies'));
			enemiesversion = localStorage.getItem('library.enemies.version');
		}
		return enemies;
	}

	/*static get casualEnemies () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.casualenemies.version') !== casualenemiesversion) {
			casualenemies = JSON.parse(localStorage.getItem('library.casualenemies'));
			casualenemiesversion = localStorage.getItem('library.casualenemies.version');
		}
		return casualenemies;
	}*/

	static get statuses () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.statuses.version') !== statusesversion) {
			statuses = JSON.parse(localStorage.getItem('library.statuses'));
			statusesversion = localStorage.getItem('library.statuses.version');
		}
		return statuses;
	}

	static get curses () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.curses.version') !== cursesversion) {
			curses = JSON.parse(localStorage.getItem('library.curses'));
			cursesversion = localStorage.getItem('library.curses.version');
		}
		return curses;
	}

	static get relics () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.relics.version') !== relicsversion) {
			relics = JSON.parse(localStorage.getItem('library.relics'));
			relicsversion = localStorage.getItem('library.relics.version');
		}
		return Object.fromEntries(Object.entries(relics).map(([key, value]) => [key, Library.upgradeItem(value)]));
	}

	static get potions () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.potions.version') !== potionsversion) {
			potions = JSON.parse(localStorage.getItem('library.potions'));
			potionsversion = localStorage.getItem('library.potions.version');
		}
		return Object.fromEntries(Object.entries(potions).map(([key, value]) => [key, Library.upgradeItem(value)]));
	}

	static get companions () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.companions.version') !== companionsversion) {
			companions = JSON.parse(localStorage.getItem('library.companions'));
			companionsversion = localStorage.getItem('library.companions.version');
		}
		return companions;
	}

	static get quests () {
		
		if (DYNAMIC_LIBRARY && localStorage.getItem('library.quests.version') !== questsversion) {
			quests = JSON.parse(localStorage.getItem('library.quests'));
			questsversion = localStorage.getItem('library.quests.version');
		}
		return quests;
	}

	static upgradeCard (card) {

		if (card.upgrades && card.champion) {
			let rank = User.dataFor(card.champion, User.difficulty).devotion.cards.selected;
			let l = card.level;
			if (card.translations)
				card = Object.assign({}, card, card.translations[lang]);
			card.upgrades.forEach((u,i) => {
				if ((u.level || i+2) <= rank)
					card = Object.assign({}, card, u);
			})
			if (card[lang])
				card.effect = card[lang];
			if (l)
				card.level = l;
		} else if (card.translations)
			card = Object.assign({}, card, card.translations[lang]);
		return Library.applyCardArt(card);
	}

	static cardArts (card) {

		if (!card)
			return [];
		if (Array.isArray(card.arts))
			return card.arts.filter(art => art && art.img);
		if (Array.isArray(card.img))
			return card.img.filter(art => art && art.img).map(art => ({
				img: art.img,
				level: art.level ?? art.from
			}));
		if (card.img)
			return [{ img: card.img }];
		return [];
	}

	static cardArtLevel (art) {

		return art?.level ?? art?.from ?? 1;
	}

	static cardArtUnlockLevel (card) {

		if (!card?.champion)
			return Infinity;
		return User.dataFor(card.champion, User.difficulty).level || 1;
	}

	static getUnlockedCardArts (card) {

		const arts = Library.cardArts(card);
		if (arts.length === 0)
			return [];
		const level = Library.cardArtUnlockLevel(card);
		const unlocked = arts.filter(art => Library.cardArtLevel(art) <= level);
		return unlocked.length > 0 ? unlocked : [arts[0]];
	}

	static getDefaultCardArt (card) {

		const arts = Library.cardArts(card);
		if (arts.length === 0)
			return undefined;
		return arts.find(art => art.level === undefined && art.from === undefined) || arts[0];
	}

	static getSelectedCardArt (card) {

		const unlocked = Library.getUnlockedCardArts(card);
		const selected = card?.key ? User.selectedCardArt(card.key) : undefined;
		if (selected && unlocked.some(art => art.img === selected))
			return selected;
		if (card?.champion && User.isFetishSoft(card.champion)) {
			const softArt = unlocked.find(art => art.soft);
			if (softArt)
				return softArt.img;
		}
		return unlocked[0]?.img;
	}

	static applyCardArt (card) {

		const arts = Library.cardArts(card);
		if (arts.length === 0)
			return card;
		return Object.assign({}, card, {
			arts,
			img: Library.getSelectedCardArt(Object.assign({}, card, { arts }))
		});
	}

	static cardSubtypes (card) {

		if (!card)
			return [];
		const subtypes = Array.isArray(card.subtypes) ? card.subtypes : (card.subtype ? [card.subtype] : []);
		return Array.from(new Set([
			...subtypes,
			...(card.engine ? ["engine"] : []),
			...(card.type === "augment" ? ["augment"] : [])
		]));
	}

	static hasSubtype (card, subtype) {

		return Library.cardSubtypes(card).includes(subtype);
	}

	static scalePassiveText (champion, text, level=1) {

		if (champion.passiveValue) {
			const value = champion.passiveValue.offset + champion.passiveValue.perLevel * level;
			return text.replace(/\b([1-9]\d*)\b/g, String(value));
		}
		return text.replace(/\b([1-9]\d*)\b/g, (_, n) => String(Number(n) * level));
	}

	static getCard(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.cards.version') !== cardsversion) {
			cards = JSON.parse(localStorage.getItem('library.cards'));
			cardsversion = localStorage.getItem('library.cards.version');
		}
		return cards[key];
	}

	static getUpgradedCard(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.cards.version') !== cardsversion) {
			cards = JSON.parse(localStorage.getItem('library.cards'));
			cardsversion = localStorage.getItem('library.cards.version');
		}
		return Library.upgradeCard(cards[key]);
	}

	static getUpgradedEnemy(key, difficulty=User.difficulty) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.enemies.version') !== enemiesversion) {
			enemies = JSON.parse(localStorage.getItem('library.enemies'));
			enemiesversion = localStorage.getItem('library.enemies.version');
		}
		return Library.upgradeEnemy(enemies[key], difficulty);
	}

	static getChampion(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.champions.version') !== championsversion) {
			champions = JSON.parse(localStorage.getItem('library.champions'));
			championsversion = localStorage.getItem('library.champions.version');
		}
		return champions[key];
	}

	static getFight(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.fights.version') !== fightsversion) {
			fights = JSON.parse(localStorage.getItem('library.fights'));
			fightsversion = localStorage.getItem('library.fights.version');
		}
		return fights[key];
	}

	static getAct(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.acts.version') !== actsversion) {
			acts = JSON.parse(localStorage.getItem('library.acts'));
			actsversion = localStorage.getItem('library.acts.version');
		}
		return acts[key];
	}

	static getEvent(key, power=1) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.events.version') !== eventsversion) {
			events = JSON.parse(localStorage.getItem('library.events'));
			eventsversion = localStorage.getItem('library.events.version');
		}
		return events[key] ? Library.upgradeItem(events[key], power) : events[key];
	}

	static getRunActKey(run) {

		return run?.actModel?.key || run?.act || Object.values(Library.acts).find(act => act.act === run?.floor)?.key;
	}

	static eventAvailableForRun(event, run) {

		const act = Library.getRunActKey(run);
		const eventActs = event.act ?? event.acts;

		if (Array.isArray(eventActs))
			return eventActs.includes(act);
		if (eventActs)
			return eventActs === act;

		return Array.isArray(event.floor) ? event.floor.includes(run.floor) : event.floor === run.floor;
	}

	static getSpirit(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.spirits.version') !== spiritsversion) {
			spirits = JSON.parse(localStorage.getItem('library.spirits'));
			spiritsversion = localStorage.getItem('library.spirits.version');
		}
		return spirits[key];
	}

	static getEnemy(key, difficulty="challenge") {

		/*if (DYNAMIC_LIBRARY && localStorage.getItem('library.enemies.version') !== enemiesversion) {
			enemies = JSON.parse(localStorage.getItem('library.enemies'));
			enemiesversion = localStorage.getItem('library.enemies.version');
		}*/
		return enemies[key];
	}

	static getStatus(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.statuses.version') !== statusesversion) {
			statuses = JSON.parse(localStorage.getItem('library.statuses'));
			statusesversion = localStorage.getItem('library.statuses.version');
		}
		let status = Object.assign({}, statuses[key], statuses[key].translations[lang]);
		return status;
	}

	static getCurse(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.curses.version') !== cursesversion) {
			curses = JSON.parse(localStorage.getItem('library.curses'));
			cursesversion = localStorage.getItem('library.curses.version');
		}
		return curses[key];
	}

	static upgradeItem (relic, power) {

		if (!power) {
				power = 1;
		}

    if (relic.translations)
      relic = Object.assign({}, relic, relic.translations[lang]);

    if (relic.variations && relic.variations.some(variation => variation.for === User.champion || Array.isArray(variation.for) && variation.for.includes(User.champion)))
      relic = Object.assign({}, relic, relic.variations.filter(variation => variation.for === User.champion || Array.isArray(variation.for) && variation.for.includes(User.champion))[0]);

    if (relic.translations)
      relic = Object.assign({}, relic, relic.translations[lang]);

		if (relic.upgrades) {
			let upgrade = null;
			relic.upgrades.forEach(u => {
				if (u.rank <= power)
					upgrade = u;
			})
			if (upgrade)
				relic = Object.assign({}, relic, upgrade)

			if (relic[lang])
				relic.effect = relic[lang];
		}
		return relic;
	}

	static upgradeEnemy (enemy, difficulty=User.difficulty) {

    if (enemy.translations)
      enemy = Object.assign({}, enemy, enemy.translations[lang]);

    if (difficulty === "casual" || difficulty === "zen")
    	enemy = Object.assign({}, enemy, { hp: [Math.round(enemy.hp[0] * CASUAL_HP_RATIO), Math.round(enemy.hp[1] * CASUAL_HP_RATIO)] }, enemy.casual);
    else if (difficulty === "hardcore")
    	enemy = Object.assign({}, enemy, { hp: [Math.round(enemy.hp[0] * HARDCORE_HP_RATIO), Math.round(enemy.hp[1] * HARDCORE_HP_RATIO)] }, enemy.hardcore);

    if (enemy.variations && enemy.variations.some(variation => variation.for === User.champion || Array.isArray(variation.for) && variation.for.includes(User.champion)))
      enemy = Object.assign({}, enemy, enemy.variations.filter(variation => variation.for === User.champion || Array.isArray(variation.for) && variation.for.includes(User.champion))[0]);

    enemy = Object.assign({}, enemy, {
      patterns: (enemy.patterns || []).map(pattern => Object.assign({}, pattern))
    });

    if (difficulty === "casual" || difficulty === "zen") {
    	enemy.patterns.forEach((p, i) => {
    		if (p.casual)
    			enemy.patterns[i] = Object.assign({}, p, p.casual);
    	});
    }
    else if (difficulty === "hardcore") {
    	enemy.patterns.forEach((p, i) => {
    		if (p.hardcore)
    			enemy.patterns[i] = Object.assign({}, p, p.hardcore);
    	});
    }

    if (enemy.translations)
      enemy = Object.assign({}, enemy, enemy.translations[lang]);

		return enemy;
	}

	/*static getRelic(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.relics.version') !== relicsversion) {
			relics = JSON.parse(localStorage.getItem('library.relics'));
			relicsversion = localStorage.getItem('library.relics.version');
		}
		return relics[key];
	}*/

	static getRelic(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.relics.version') !== relicsversion) {
			relics = JSON.parse(localStorage.getItem('library.relics'));
			relicsversion = localStorage.getItem('library.relics.version');
		}
		return relics[key];
	}

	static getUpgradedRelic(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.relics.version') !== relicsversion) {
			relics = JSON.parse(localStorage.getItem('library.relics'));
			relicsversion = localStorage.getItem('library.relics.version');
		}
		return Library.upgradeItem(relics[key]);
	}

	/*static getPotion(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.potions.version') !== potionsversion) {
			potions = JSON.parse(localStorage.getItem('library.potions'));
			potionsversion = localStorage.getItem('library.potions.version');
		}
		return potions[key];
	}*/

	static getPotion(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.potions.version') !== potionsversion) {
			potions = JSON.parse(localStorage.getItem('library.potions'));
			potionsversion = localStorage.getItem('library.potions.version');
		}
		return Library.upgradeItem(potions[key]);
	}

	static getCompanion(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.companions.version') !== companionsversion) {
			companions = JSON.parse(localStorage.getItem('library.companions'));
			companionsversion = localStorage.getItem('library.companions.version');
		}
		return companions[key];
	}

	static getQuest(key) {

		if (DYNAMIC_LIBRARY && localStorage.getItem('library.quests.version') !== questsversion) {
			quests = JSON.parse(localStorage.getItem('library.quests'));
			questsversion = localStorage.getItem('library.quests.version');
		}
		return quests[key];
	}
}
